angular.module('salesPath2.spd')
  .factory('spdAdditionalDataAttributes', [function() {
    var attributes = {
      'isYoungDriver': ['Simple', 'Boolean'] //uzytkownik do 25 roku zycia
    };
    return attributes;
  }]);